import { render } from "./PrintType.vue?vue&type=template&id=1565a8a1"
import script from "./PrintType.vue?vue&type=script&lang=js"
export * from "./PrintType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__